import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      width: '395px',
      height: '535px',
      padding: '24px 32px',
      paddingBottom: '0px',
      '& .MuiDialogTitle-root': {
        padding: '0px',
        marginBottom: '32px'
      },
      '& .divider': {
        backgroundColor: colorSet.backgroundLight,
        height: '1px'
      },
      '& .MuiDialogContent-root': {
        marginTop: '16px',
        padding: '32px 0px',
        color: '#323D45',
        whiteSpace: 'pre-line',
        '& br': {
          '&:after': {
            content: ''
          }
        },
        '& .title': {
          wordBreak: 'break-all',
          fontSize: '20px',
          fontWeight: '700',
          lineHeight: '32px'
        },
        '& .subTitle': {
          wordBreak: 'break-all',
          fontSize: '14px',
          fontWeight: '700',
          lineHeight: '20px'
        },
        '& .content': {
          wordBreak: 'break-all',
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '20px'
        }
      }
    }
  }
}));
